// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"e32d2d38","419":"c6087cb1","787":"2a38e5c6"}[chunkId] + ".chunk.js";
};